export default __webpack_public_path__ + "static/media/user-friendly-data.5bf3693f.png";